"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAdvantage() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="146437" id="affärsfall-och-kalkyl" className="bg-secondary text-foreground w-full overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-stretch">
          
          {/* Text Column */}
          <div ref={textRef} className={`lg:col-span-7 py-16 lg:py-32 lg:pr-16 relative flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-px bg-primary"></div>
              <span className="font-mono text-primary text-sm tracking-widest uppercase">
                Kalkylator
              </span>
            </div>
            
            <h2 className="font-serif text-2xl md:text-3xl lg:text-[32px] leading-tight mb-8 uppercase tracking-tight">
              Affärsfall & ROI-Kalkyl
            </h2>
            
            <p className="text-muted-foreground text-lg md:text-xl leading-relaxed max-w-2xl font-serif">
              Vi tillämpar en disciplinerad, kirurgisk metod för att beräkna er affärsnytta inom autonoma transporter. Genom att eliminera det oväsentliga och fokusera strikt på strukturell integritet och operativ prestanda, levererar vi beslutsunderlag som är fundamentalt överlägsna. Vår metodik säkerställer transparens och precision i varje ROI-modell, från driftskostnader till skalningspotential.
            </p>

            {/* Vertical Divider Line */}
            <div className="hidden lg:block absolute right-0 top-0 bottom-0 w-px bg-primary"></div>
          </div>

          {/* Visual Column */}
          <div ref={imgRef} className={`lg:col-span-5 relative min-h-[400px] lg:min-h-full transition-all duration-1000 delay-300 ease-out ${isImgVisible ? "opacity-100" : "opacity-0"}`}>
            {/* Color Overlay */}
            <div className="absolute inset-0 bg-primary/20 z-10 mix-blend-multiply"></div>
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/abstract_glass_facade_structure.png" alt="Teknisk illustration av ROI-modeller" className="absolute inset-0 w-full h-full object-cover grayscale mix-blend-luminosity opacity-70" />
            
            {/* Horizontal Divider Line for Mobile */}
            <div className="block lg:hidden absolute top-0 left-0 right-0 h-px bg-primary"></div>
          </div>

        </div>
      </div>
    </section>;
}